import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="order-modal"
export default class extends Controller {
  static targets = [
    "modal", "itemName", "quantity", "form", "name", "souvenirId"
  ]

  connect() {}

  // Handler for grid/list "Order here"
  open(event) {
    event.preventDefault()
    this.showModal({
      itemName: event.currentTarget.getAttribute("data-item-name"),
      souvenirId: event.currentTarget.getAttribute("data-cultural-souvenir-id"),
      quantity: 1
    })
  }

  // Handler for show page "Order here" (with custom qty)
  openShowPage(event) {
    event.preventDefault();
    const itemName = event.currentTarget.getAttribute("data-item-name");
    const souvenirId = event.currentTarget.getAttribute("data-cultural-souvenir-id");
    const qtySelector = event.currentTarget.getAttribute("data-qty-selector");
    let quantity = 1;
    if (qtySelector) {
      const qtyElem = document.querySelector(qtySelector);
      if (qtyElem && qtyElem.textContent) {
        const q = parseInt(qtyElem.textContent.trim(), 10);
        if (!isNaN(q)) quantity = q;
      }
    }
    this.showModal({ itemName, souvenirId, quantity });
  }

  // Shared logic for showing modal and prefilling fields
  showModal({ itemName, souvenirId, quantity }) {
    this.itemNameTarget.value = itemName;
    this.souvenirIdTarget.value = souvenirId;
    this.quantityTarget.value = quantity;

    // Autofill user name only if available
    const registry = window.userControllerRegistry
    if (registry && registry.data && registry.data.authenticated && this.hasNameTarget) {
      const user = registry.data.user
      if (user && user.name) {
        this.nameTarget.value = user.name
      }
    }

    this.show();
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add("hidden")
  }

  show() {
    this.modalTarget.classList.remove("hidden")
  }
}
